<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-膳食习惯调查
-->

<template>
  <div class="bodyinfo-page">
    <div class="title">膳食习惯调查</div>
    <div class="form-wrapper">
      <van-form @submit="onSubmit" :scroll-to-error="true">
        <div class="form-item" v-for="item in qsList" :key="item.name">
          <div class="form-item-label">{{ item.label }}</div>
          <div class="form-item-input">
            <van-field :name="item.name" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-radio-group v-model="formData[item.name]" direction="vertical" icon-size="1.33rem">
                  <van-radio class="van-radio__label" v-for="opt in item.options" :key="opt.key" :name="opt.key"
                    checked-color="#FBB13D">{{ opt.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>

        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" native-type="button" plain @click="$emit('prev-step')">上一页</van-button>
          <van-button round block color="#FBB13D" type="info" native-type="submit">下一页</van-button>
        </div>
      </van-form>

    </div>
  </div>
</template>

<script>
// import {getQueryString} from '../utils/utils'
export default {
  name: 'DietaryHabits',
  props: {
    initData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      qsList: [{
        label: '1.您平均一天能吃多少主食？（谷薯类，1份≈25g生米/面或65g熟米饭或35g馒头）',
        name: 'dietHabitEatMainFood',
        options: [{
          label: "≤3份",
          key: '1'
        }, {
          label: "3-4份",
          key: '2'
        }, {
          label: "5-6份",
          key: '3'
        }, {
          label: "≥7份",
          key: '4'
        }]
      }, {
        label: '2.您平均一天能吃多少深色蔬菜（菠菜、西蓝花、胡萝卜等）？（1份≈500g大白菜/菠菜或200g胡萝卜）',
        name: 'dietHabitEatVegetable',
        options: [{
          label: "≤1份",
          key: '1'
        }, {
          label: "1-2份",
          key: '2'
        }, {
          label: "2-3份",
          key: '3'
        }, {
          label: "≥3份",
          key: '4'
        }]
      }, {
        label: '3.您平均每周能吃多少红肉（猪、牛、羊等）？（1份≈50g瘦猪肉/牛肉或35g熟叉烧）',
        name: 'dietHabitEatRedMeat',
        options: [{
          label: "≤2份",
          key: '1'
        }, {
          label: "3-4份",
          key: '2'
        }, {
          label: "5-6份",
          key: '3'
        }, {
          label: "≥7份",
          key: '4'
        }]
      }, {
        label: '4.您平均每周能吃多少海鲜（鱼、虾、贝类等）？（1份≈80g鱼/虾）',
        name: 'dietHabitEatSeafood',
        options: [{
          label: "≤2份",
          key: '1'
        }, {
          label: "3-4份",
          key: '2'
        }, {
          label: "5-6份",
          key: '3'
        }, {
          label: "≥7份",
          key: '4'
        }]
      }, {
        label: '5.您平均每一天能喝多少酸奶/牛奶？（1份≈160g牛奶）',
        name: 'dietHabitDrinkMilk',
        options: [{
          label: "几乎不喝",
          key: '1'
        }, {
          label: "1-2份",
          key: '2'
        }, {
          label: "≥3份",
          key: '3'
        }]
      }, {
        label: '6.您平均每一天能吃多少水果？（1份≈200g苹果/梨） ',
        name: 'dietHabitEatFruit',
        options: [{
          label: "几乎不吃",
          key: '1'
        }, {
          label: "1-2份",
          key: '2'
        }, {
          label: "≥3份",
          key: '3'
        }]
      }, {
        label: '7.家庭人均食用油日用量是多少？（1份≈1汤匙/10g花生油/玉米油/菜籽油）',
        name: 'dietHabitOilUsed',
        options: [{
          label: "≤1份",
          key: '1'
        }, {
          label: "1-2份",
          key: '2'
        }, {
          label: "≥2份",
          key: '3'
        }]
      }, {
        label: '8.家庭用盐量（5口之家/月）？',
        name: 'dietHabitSaltUsed',
        options: [{
          label: "≤500g",
          key: '1'
        }, {
          label: "500-1000g",
          key: '2'
        }, {
          label: "≥1000g",
          key: '3'
        }]
      }, {
        label: '9.您平均每一天添加糖的摄入（含甜饮料、糕点）？（1份≈2汤匙/22.5g白砂糖）',
        name: 'dietHabitEatSugar',
        options: [{
          label: "几乎不吃",
          key: '1'
        }, {
          label: "1-2份",
          key: '2'
        }, {
          label: "≥3份",
          key: '3'
        }]
      }, {
        label: '10.早餐规律性？',
        name: 'dietHabitBreakfastRegularity',
        options: [{
          label: "每日食用",
          key: '1'
        }, {
          label: "每周3-6次",
          key: '2'
        }, {
          label: "极少",
          key: '3'
        }]
      }, {
        label: '11.外出就餐频率？',
        name: 'dietHabitOutEatFrequency',
        options: [{
          label: "每周≤1次",
          key: '1'
        }, {
          label: "每周2-3次",
          key: '2'
        }, {
          label: "≥4次/周",
          key: '3'
        }]
      }, {
        label: '12.饮水习惯？',
        name: 'dietHabitDrinkingWatter',
        options: [{
          label: "每日≥1.5升",
          key: '1'
        }, {
          label: "1-1.5升",
          key: '2'
        }, {
          label: "≤1升",
          key: '3'
        }]
      }],
      formData:{

      dietHabitEatMainFood: '',
      dietHabitEatVegetable: '',
      dietHabitEatRedMeat: '',
      dietHabitEatSeafood: '',
      dietHabitDrinkMilk: '',
      dietHabitEatFruit: '',
      dietHabitOilUsed: '',
      dietHabitSaltUsed: '',
      dietHabitEatSugar: '',
      dietHabitBreakfastRegularity: '',
      dietHabitOutEatFrequency: '',
      dietHabitDrinkingWatter: '',
      }
    }
  },
  created() {

  },
  mounted() {
    this.formData = {...this.initData}
  },
  methods: {
    onSubmit(values) {
      let query = { ...values }
      console.log('onSubmit',values, query);
      this.$emit('next-step',{type:'dietaryHabits',data:query})
    },
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.bodyinfo-page {
  width: 100%;
  height: 100vh;
  padding: 2rem;
  background-color: #fff;
}

.bodyinfo-page .title {
  height: 2.33rem;
  font-weight: 500;
  font-size: 1.67rem;
  color: #333333;
  line-height: 2.33rem;
  margin-bottom: 2rem;
}

.form-wrapper {
  padding-bottom: 5rem;
}

.form-wrapper .form-item {
  margin-bottom: 2rem;
}

.form-wrapper .form-item .form-item-label {
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  text-align: left;
  margin-bottom: 1rem;
}

.form-wrapper .form-item .form-item-input {
  /* width: 100%;
  height: 3.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  background: #F8F9FA; */
}

.icon-mark {
  width: 100px;
  font-size: 1.17rem;
}

.form-wrapper .form-item .form-item-input .van-cell {
  /* background: #F8F9FA; */
  padding-left: 0;
  border-bottom: 1px solid #e8e9ec;
}

.next-btn-wrapper {
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap: 1.42rem;
  background-color: #fff;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}

.form-wrapper .form-item .van-radio__label,
.bodyinfo-page .van-radio__label {
  font-size: 1.33rem;
  margin-bottom: 1rem;
}
</style>
